import { EdgeVerifyInvitationRepository } from '@/modules/auth/infra/repositories'
import { makeAnonEdgeHttpClient } from '@/main/factories/http'
import type { VerifyInvitationToken } from '@/modules/auth/use-cases'

export function makeVerifyInvitationToken(): VerifyInvitationToken {
  return new EdgeVerifyInvitationRepository(makeAnonEdgeHttpClient()).execute
}
